import axios from 'axios';

const BASE = 'api/lms/school-analytics';
const QUIZ_BASE = 'api/lms/quiz-analytics';
const ASSIGNMENT_BASE = 'api/lms/assignment-analytics';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getEnrollmentsGraph(_obj, params) {
    const res = await axios.get(`${BASE}/enrollments-graph/`, { params });
    return res.data;
  },
  async getCompletionFunnel(_obj, params) {
    const res = await axios.get(`${BASE}/completion-funnel/`, { params });
    return res.data;
  },
  async getCourseLeaderboard(_obj, params) {
    const res = await axios.get(`${BASE}/course-leaderboard/`, { params });
    return res.data;
  },
  async getCourseStructureEngagement(_obj, params) {
    const res = await axios.get(`${BASE}/course-structure-engagement/`, { params });
    return res.data;
  },

  // Sync CSV exports — return { url }
  async exportEnrollmentsOverTime(_obj, params) {
    const res = await axios.get(`${BASE}/export-enrollments-over-time-csv/`, { params });
    return res.data;
  },
  async exportCourseLeaderboard(_obj, params) {
    const res = await axios.get(`${BASE}/export-course-leaderboard-csv/`, { params });
    return res.data;
  },
  async exportCourseStructureEngagement(_obj, params) {
    const res = await axios.get(`${BASE}/export-course-structure-engagement-csv/`, { params });
    return res.data;
  },
  async exportCourseRoster(_obj, params) {
    const res = await axios.get(`${BASE}/export-course-roster-csv/`, { params });
    return res.data;
  },

  // General Roster Report (multi-course). Backend currently runs inline and
  // returns { timestamp }; the URL is delivered via WS room when Celery is wired.
  async createCourseRosterReport(_obj, data) {
    const res = await axios.post(`${BASE}/course-roster-report/`, data);
    return res.data;
  },

  // ---- Quiz-wise reporting (TWD-2846 / TWD-2847) ----
  async getQuizAnalyticsOverview(_obj, params) {
    const res = await axios.get(`${QUIZ_BASE}/overview/`, { params });
    return res.data;
  },
  async getQuizLeaderboard(_obj, params) {
    const res = await axios.get(`${QUIZ_BASE}/quiz-leaderboard/`, { params });
    return res.data;
  },
  async getQuizQuestionBreakdown(_obj, params) {
    const res = await axios.get(`${QUIZ_BASE}/question-breakdown/`, { params });
    return res.data;
  },
  async getQuizAttemptsBreakdown(_obj, params) {
    const res = await axios.get(`${QUIZ_BASE}/attempts-breakdown/`, { params });
    return res.data;
  },
  async exportQuizQuestionReport(_obj, params) {
    const res = await axios.get(`${QUIZ_BASE}/export-question-report-csv/`, { params });
    return res.data;
  },
  async getAssessmentActivityGraph(_obj, params) {
    const res = await axios.get(`${QUIZ_BASE}/activity-graph/`, { params });
    return res.data;
  },
  // POST: filters travel in the body alongside `include`, as the roster report does.
  async generateAssessmentReport(_obj, payload) {
    const res = await axios.post(`${QUIZ_BASE}/assessment-report/`, payload);
    return res.data;
  },

  // ---- Assignment reporting ----
  async getAssignmentAnalyticsOverview(_obj, params) {
    const res = await axios.get(`${ASSIGNMENT_BASE}/overview/`, { params });
    return res.data;
  },
  async getAssignmentLeaderboard(_obj, params) {
    const res = await axios.get(`${ASSIGNMENT_BASE}/assignment-leaderboard/`, { params });
    return res.data;
  },
  async getAssignmentActivityGraph(_obj, params) {
    const res = await axios.get(`${ASSIGNMENT_BASE}/activity-graph/`, { params });
    return res.data;
  },
  async getAssignmentStudents(_obj, params) {
    const res = await axios.get(`${ASSIGNMENT_BASE}/students/`, { params });
    return res.data;
  },
  async generateAssignmentReport(_obj, payload) {
    const res = await axios.post(`${ASSIGNMENT_BASE}/assignment-report/`, payload);
    return res.data;
  },
};

export const lmsAnalytics = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
